var _rect, _rect2, _rect3, _rect4, _path, _rect5, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiDocumentImportError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 101,
    viewBox: "0 0 88 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.21,
    y: 27.9924,
    width: 16.8479,
    height: 4.49277,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7173,
    y: 32.4851,
    width: 4.49277,
    height: 4.49277,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8403,
    y: 17.8835,
    width: 4.49277,
    height: 5.61596,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9346,
    y: 16.7605,
    width: 5.61596,
    height: 7.86235,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6885 19.0071H58.7972V22.3767H48.6885V19.0071Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0576,
    y: 32.4851,
    width: 4.49277,
    height: 4.49277,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3427 50.9921H41.5682V70.2176H26.4966C21.9848 70.2176 17.6949 73.1549 15.3688 76.22C15.3688 76.22 11.4377 81.3921 8.62969 86.0716C5.19764 91.7912 0.391113 101 0.391113 101H6.56867C6.56867 101 12.5748 90.0028 14.2457 87.1948C16.2506 83.8252 19.8616 79.5017 19.8616 79.5017C22.3427 76.22 23.9541 76.1283 26.4842 76.1283L62.5444 76.22C65.0748 76.22 67.7828 79.5017 67.7828 79.5017C67.7828 79.5017 70.9669 83.8252 74.8981 90.0028C78.8292 96.1804 81.8226 101 81.8226 101H88.0001C88.0001 101 80.8791 88.4528 79.3908 86.0716C76.5828 81.5789 73.2133 77.0861 73.2133 77.0861C70.7121 73.3311 67.0509 70.2176 62.5444 70.2176H47.4727V50.9921H66.6982C76.4899 50.9921 84.4455 43.0375 84.4455 33.2449V18.4562C84.4455 8.66459 76.4909 0.708984 66.6982 0.708984H22.3322C12.5405 0.708984 4.58495 8.66361 4.58495 18.4562V33.2449C4.58495 43.0365 12.5395 50.9921 22.3322 50.9921H22.3427ZM10.5116 18.4558C10.5116 11.9337 15.8206 6.62466 22.3427 6.62466H66.7088C73.2309 6.62466 78.54 11.9337 78.54 18.4558V33.2445C78.54 39.7666 73.2309 45.0757 66.7088 45.0757H22.3427C15.8206 45.0757 10.5116 39.7666 10.5116 33.2445V18.4558Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDocumentImportError);
export default __webpack_public_path__ + "static/media/ai_document_import_error.6278acd626c3160088d15052993e001d.svg";
export { ForwardRef as ReactComponent };